"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckbox = exports.StyledCheckboxInput = exports.StyledCheckboxIconComponent = exports.StyledCheckboxLabel = exports.VERTICAL_PADDING = exports.visuallyHidden = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const CheckboxIcon_1 = require("./components/CheckboxIcon/CheckboxIcon");
const CheckboxIcon_styles_1 = require("./components/CheckboxIcon/CheckboxIcon.styles");
const helpers_1 = require("../../helpers");
const StackView_1 = require("../../StackView");
const Text_1 = require("../../Text");
exports.visuallyHidden = (0, styled_components_1.css) `
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    border: 0;
    padding: 0;

    white-space: nowrap;
    clip-path: inset(100%);
    clip: rect(0 0 0 0);
    overflow: hidden;
`;
const ICON_SIZE = '20px';
exports.VERTICAL_PADDING = `${(parseInt(helpers_1.SPACING_XL, 10) - parseInt(ICON_SIZE, 10)) / 2}px`;
exports.StyledCheckboxLabel = (0, styled_components_1.default)(Text_1.Text) ``;
exports.StyledCheckboxIconComponent = (0, styled_components_1.default)(CheckboxIcon_1.CheckboxIcon) `
    min-width: ${ICON_SIZE};
    max-width: ${ICON_SIZE};
`;
exports.StyledCheckboxInput = styled_components_1.default.input `
    ${exports.visuallyHidden}
`;
exports.StyledCheckbox = (0, styled_components_1.default)(StackView_1.StackView) `
    position: relative; // for StyledCheckboxInput
    display: inline-flex;
    padding: ${exports.VERTICAL_PADDING} 0;
    cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
    max-width: 100%; // for text truncation

    ${({ buildIn }) => buildIn &&
    (0, styled_components_1.css) `
            ${exports.StyledCheckboxIconComponent} {
                margin: auto;
            }
        `}

    ${CheckboxIcon_styles_1.StyledCheckboxIconCenterFigure} {
        color: ${({ theme }) => theme.colorControlElement};
    }

    ${exports.StyledCheckboxIconComponent} {
        flex-shrink: 0;
        background-color: ${({ theme }) => theme.colorBackgroundBlank};
        margin-right: ${({ hasLabel }) => (hasLabel ? helpers_1.SIZE_S : undefined)};
    }

    ${({ theme }) => (0, styled_components_1.css) `
        ${exports.StyledCheckboxLabel} {
            margin: calc((${ICON_SIZE} - ${theme.fonts.lineHeights.m}) / 2) 0;
        }
    `}

    ${({ theme, isError, isDisabled }) => {
    if (isDisabled) {
        return (0, styled_components_1.css) `
                ${CheckboxIcon_styles_1.StyledCheckboxIconBorder} {
                    color: ${theme.colorControlBorderDisabled};
                }

                ${CheckboxIcon_styles_1.StyledCheckboxIconCenterFigure} {
                    color: ${theme.colorControlIconDisabled};
                }
            `;
    }
    if (isError) {
        return (0, styled_components_1.css) `
                ${CheckboxIcon_styles_1.StyledCheckboxIconBorder} {
                    color: ${theme.colorBorderError};
                }

                &:focus-within,
                &:hover {
                    ${exports.StyledCheckboxIconComponent} {
                        background-color: ${theme.colorHighlightErrorLight};
                    }
                }

                &:active {
                    ${exports.StyledCheckboxIconComponent} {
                        background-color: ${theme.colorHighlightErrorDark};
                    }
                }
            `;
    }
    return (0, styled_components_1.css) `
            ${CheckboxIcon_styles_1.StyledCheckboxIconBorder} {
                color: ${theme.colorControlBorder};
            }

            &:focus-within,
            &:hover,
            &:active {
                ${CheckboxIcon_styles_1.StyledCheckboxIconBorder} {
                    color: ${theme.colorControlBorderAccent};
                }
            }

            &:hover {
                ${exports.StyledCheckboxIconComponent} {
                    background-color: ${theme.colorHighlightLight};
                }
            }

            &:active {
                ${exports.StyledCheckboxIconComponent} {
                    background-color: ${theme.colorHighlightDark};
                }
            }
        `;
}}
`;
//# sourceMappingURL=Checkbox.styles.js.map